import {i18n} from '@lingui/core';
import {isRTL} from './rtl';

export {i18n, isRTL};

export async function load(locale = 'en') {
  try {
    const {messages} = await import(`./messages/${locale}.ts`);
    i18n.loadAndActivate({locale, messages});
  } catch (e) {}
}
